























import { Vue, Component, Prop, Watch, Ref } from 'vue-property-decorator';
import EditorSection from '@/editor/editor-block-view/components/EditorSection.vue';
import { IEditorContent, ISection, IMergeValues } from '@/editor/types';
import { EditorHelper } from '@/editor/helpers/editor.helper';
import { EBlockWidth, EContext } from '@/editor/types/enums';
import {
  EditorView,
  EditorViewAction,
} from '@/editor/editor-block-view/store/editor-view.constants';
import { UpdateInputFieldRequest } from '@/editor/api/services/types/requests';
import { IRecipient } from '@lib-shared/types/Recipient';
import { IUser } from '@/types/User';
import { IEditorRecipientInput } from '@lib-shared/types/editor-recipient-input';
import { Document, EDocumentAction } from '@signing-page/documents/store/document.constants';

@Component({
  components: {
    EditorSection,
  },
})
export default class EditorBlockView extends Vue {
  @Prop() content: IEditorContent;
  @Prop() focusedRequiredId?: string;
  @Prop() mergeValues: IMergeValues;
  @Prop({ default: false }) isPdfViewer: boolean;
  @Prop() pageWidth: number;
  @Prop({ default: false }) isBlockToggled: boolean;
  @Prop({ default: false }) isSigningSite: boolean;
  @Prop() blockId: string;
  @Prop() sender: IUser;
  @Prop() recipient: IRecipient;
  @Prop({ default: () => [] }) recipientInput!: IEditorRecipientInput[];
  @Prop({ default: () => EContext.Document }) context: EContext;
  @EditorView.Action(EditorViewAction.UpdateInputValue) actionUpdateInputValue: (
    payload: UpdateInputFieldRequest
  ) => void;
  @Document.Action(EDocumentAction.SetEditorRecipientInput) actionSetEditorRecipientInput: (
    editorRecipientInput: IEditorRecipientInput[]
  ) => void;
  @Watch('pageWidth', { immediate: true }) watchPageWidth() {
    Vue.nextTick(() => {
      this.setBlockWidth(this.pageWidth || this.editorContainer?.offsetWidth);
    });
  }

  @Ref('editorContainer') editorContainer: HTMLElement;

  blockWidthClass: EBlockWidth = null;

  get sections(): ISection[] {
    return this.content?.sections;
  }

  handleUpdateInputValue({ id: fieldId, value }: { id: string; value: string }) {
    this.actionSetEditorRecipientInput(
      this.recipientInput.filter(input => input.fieldId !== fieldId).concat({ fieldId, value })
    );
    this.actionUpdateInputValue({
      value,
      fieldId,
      blockId: this.blockId,
    });
  }

  setBlockWidth(width: number) {
    const blockWidth = EditorHelper.getBlockWidth(width);
    this.blockWidthClass = EditorHelper.getBlockWidthClass(blockWidth);
  }

  mounted() {
    Vue.nextTick(() => {
      this.$emit('loaded');
    });
  }
}
